module.exports = __webpack_public_path__ + "img/hc_rm@2x.d8db5958.png";